
import Vue from "vue";
import ScorecardDetails from "@/features/Scores/ScorecardDetails.vue";
import IncidentDetails from "@/features/Incidents/IncidentDetails.vue";
import SupplierEventDetails from "@/features/SupplierEvents/SupplierEventDetails.vue";
import ScrollablePane from "@/shared/components/ScrollablePane.vue";

export enum DetailsPaneObjectType {
    Score = "Score",
    Scorecard = "Scorecard",
    Incident = "Incident",
    SupplierEvent = "Supplier Event",
}

export default Vue.extend({
    name: "DetailsPane",
    components: {
        ScorecardDetails,
        IncidentDetails,
        SupplierEventDetails,
        ScrollablePane,
    },
    data: () => ({
        detailsPaneObjectTypes: DetailsPaneObjectType,
    }),
    props: {
        supplierID: {
            type: String,
            required: true,
        },
        // A DetailsPaneObjectType value; establishes whether we're showing details for a scorecard, incident, etc
        objectType: {
            type: String,
            required: true,
        },
        scoreID: {
            type: String,
            required: false,
        },
        scorecardID: {
            type: String,
            required: false,
        },
        incidentID: {
            type: String,
            required: false,
        },
        supplierEventID: {
            type: String,
            required: false,
        },
        createNewObject: {
            type: Boolean,
            default: false,
        },
    },
    computed: {},
    methods: {
        closeDetails() {
            this.$emit("detailsClosed");
        },
        scorecardUpdated() {
            this.$emit("scorecard-updated");
        },
        incidentUpdated() {
            this.$emit("incident-updated");
        },
        supplierEventUpdated() {
            this.$emit("supplier-event-updated");
        },
    },
});
